import './ManagedWidget.css';
import React, { useContext, useState, useRef, useEffect } from 'react';
import debounce from 'lodash.debounce';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
const ManagedWidget = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const {
    layoutStyle: layoutStyleAnalytics,
    interactionWithWidget: interactionWithWidgetAnalytics,
    copyCode: copyCodeAnalytics
  } = fields.data;
  const codeDescription = get(fields, 'data.datasource.codeDescription.jss.value');
  const iframeBaseLink = (canUseDOM ? window.location.origin : '') + get(fields, 'data.datasource.baseUrl.jss.value.href', '');
  const makeIFrameHTML = _ref2 => {
    let {
      type,
      color
    } = _ref2;
    let params = '';
    const isDesktop = window.innerWidth >= 768;
    if (canUseDOM && isDesktop) {
      params = `type=${encodeURIComponent(type)}&`;
    }
    return `<iframe ${isDesktop ? 'style="border: 1px solid #C7C7C7;"' : 'frameborder="0" width="325"'} src="${iframeBaseLink}?${params}color=${color.slice(1)}"></iframe>`;
  };
  const layoutStyles = get(fields, 'data.datasource.layoutStyle.styles', []);
  const baseLayoutStyle = get(layoutStyles, '0.value.jss.value');
  const baseLayoutStyleTitle = get(layoutStyles, '0.title.jss.value');
  const baseColor = '#6E2B62';
  const [selectedLayoutStyle, setLayoutStyle] = useState(baseLayoutStyle);
  const [iframeHTML, setIFrameHTML] = useState('');
  const [layoutColor, setLayoutColor] = useState(baseColor);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const variables = BackgroundColorHex ? {
    "--managed-widget-primary-color": BackgroundColorHex,
    "--managed-widget-primary-active-color": ActiveColorHex,
    "--managed-widget-color": ColorHex
  } : {
    "--managed-widget-primary-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--managed-widget-primary-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--managed-widget-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const iframeURLRef = useRef();
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues') || [];
  const mapDictionary = dictionaryValues.reduce((map, currentValue) => map.set(currentValue.key.jss.value, currentValue.phrase.jss.value), new Map());
  const setDebounceLayoutColor = debounce(setLayoutColor, 500);
  const setNewIFrame = () => {
    setIFrameHTML(makeIFrameHTML({
      type: selectedLayoutStyle,
      color: layoutColor
    }));
  };
  const handleLaoutStyleClick = (e, layoutStyle) => {
    e.preventDefault();
    tealiumClickFunc(tealiumMergeClickData(layoutStyleAnalytics, params), layoutStyle.value.jss.value);
    setLayoutStyle(layoutStyle.value.jss.value);
  };
  const renderLayoutsOptions = () => {
    return layoutStyles.map((layoutStyle, index) => {
      return /*#__PURE__*/React.createElement("div", {
        className: "m-widget-layouts__item",
        onClick: e => handleLaoutStyleClick(e, layoutStyle),
        key: index
      }, /*#__PURE__*/React.createElement("input", {
        tabIndex: 0,
        onKeyPress: event => {
          if (event.key === "Enter" || event.key === "NumpadEnter") {
            handleLaoutStyleClick(event, layoutStyle);
          }
        },
        type: "radio",
        value: layoutStyle.value.jss.value,
        name: "m-widget-layout-style",
        checked: layoutStyle.value.jss.value === selectedLayoutStyle
      }), /*#__PURE__*/React.createElement("label", {
        className: "body-small m-widget-layouts__label"
      }, /*#__PURE__*/React.createElement("span", {
        className: "m-widget-layouts__label-text"
      }, layoutStyle.title.jss.value)));
    });
  };
  const copy = () => {
    const fallback = () => {
      iframeURLRef.current.select();
      if (canUseDOM) {
        document.execCommand('copy');
        tealiumClickFunc(tealiumMergeClickData(copyCodeAnalytics, params));
      }
    };
    if (navigator.clipboard) {
      try {
        navigator.clipboard.writeText(iframeHTML);
        tealiumClickFunc(tealiumMergeClickData(copyCodeAnalytics, params));
      } catch (error) {
        fallback();
      }
    } else {
      fallback();
    }
  };
  useEffect(() => {
    if (canUseDOM) {
      const windowResizeHandler = debounce(() => setNewIFrame(), 500);
      window.addEventListener('resize', windowResizeHandler);
      return () => window.removeEventListener('resize', windowResizeHandler);
    }
  }, []);
  useEffect(() => setNewIFrame(), [selectedLayoutStyle]);
  if (!fields) {
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ManagedWidget component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget offset-xl-1",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts__head"
  }, mapDictionary.get('LayoutStyle')), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-layouts__body"
  }, renderLayoutsOptions())), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__head"
  }, mapDictionary.get('PickColor')), /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__body"
  }, /*#__PURE__*/React.createElement("input", {
    id: "m-widget-color-picker",
    type: "color",
    value: layoutColor,
    className: "m-widget-color__picker-control",
    onChange: e => {
      setDebounceLayoutColor(e.currentTarget.value.toUpperCase());
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "m-widget-color-picker",
    className: "m-widget-color__picker",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__picker-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-widget-color__picker-square",
    style: {
      backgroundColor: layoutColor
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "m-widget-color__picker-hex"
  }, layoutColor))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    onClick: () => {
      setNewIFrame();
      tealiumClickFunc(tealiumMergeClickData(interactionWithWidgetAnalytics, params));
    }
  }, mapDictionary.get('UpdateWidget')))), /*#__PURE__*/React.createElement("div", {
    className: "m-widget__iframe",
    key: iframeHTML,
    dangerouslySetInnerHTML: {
      __html: iframeHTML
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "widget-code"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "h4 widget-code__title"
  }, mapDictionary.get('WidgetCode')), /*#__PURE__*/React.createElement("div", {
    className: "widget-code__desc"
  }, codeDescription), /*#__PURE__*/React.createElement("textarea", {
    dir: "ltr",
    className: "widget-code__txt-area",
    ref: iframeURLRef,
    rows: 4,
    disabled: true,
    value: iframeHTML
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary widget-code__copy",
    onClick: copy
  }, mapDictionary.get('CopyCode'))))));
};
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl,
    className
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className} module-group`,
    "data-cy": "rich-text"
  }, children);
};
const commonStyles = "cl0b85t";
const ltrStyles = "l1ifxkrs";
const rtlStyles = "r1ya69i3";
export default ManagedWidget;